import React from 'react';
import InputMask from 'react-input-mask';

interface CustomerAddressFieldsProps {
  // Form values
  cep: string;
  setCep: (value: string) => void;
  address: string;
  setAddress: (value: string) => void;
  number: string;
  setNumber: (value: string) => void;
  complement: string;
  setComplement: (value: string) => void;
  district: string;
  setDistrict: (value: string) => void;
  city: string;
  setCity: (value: string) => void;
  state: string;
  setState: (value: string) => void;
  
  // Validation states
  alarmCep: boolean;
  setAlarmCep: (value: boolean) => void;
  alarmAddress: boolean;
  setAlarmAddress: (value: boolean) => void;
  alarmNumber: boolean;
  setAlarmNumber: (value: boolean) => void;
  alarmDistrict: boolean;
  setAlarmDistrict: (value: boolean) => void;
  alarmCity: boolean;
  setAlarmCity: (value: boolean) => void;
  alarmState: boolean;
  setAlarmState: (value: boolean) => void;
  
  // Handlers
  setHideMenu: (value: boolean) => void;
  findCep: (cep: string) => Promise<boolean>;
}

export function CustomerAddressFields({
  cep, setCep, address, setAddress, number, setNumber,
  complement, setComplement, district, setDistrict,
  city, setCity, state, setState,
  alarmCep, setAlarmCep, alarmAddress, setAlarmAddress,
  alarmNumber, setAlarmNumber, alarmDistrict, setAlarmDistrict,
  alarmCity, setAlarmCity, alarmState, setAlarmState,
  setHideMenu, findCep
}: CustomerAddressFieldsProps) {
  
  return (
    <>
      <div className="input">
        <label>CEP</label>
        <InputMask
          className={`${alarmCep && "alarm-input"}`}
          mask="99999-999"
          type="text"
          value={cep}
          onChange={(event) => setCep(event.target.value)}
          onFocus={() => setHideMenu(true)}
          onBlur={(event) => {
            setHideMenu(false);
            if (cep[0] === "_") {
              setAlarmCep(true);
            } else {
              findCep(event.target.value);
              setAlarmCep(false);
            }
          }}
        />
        {alarmCep && (
          <p className="alarm-text">Informe o CEP</p>
        )}
      </div>
      
      <div className="input">
        <label>Endereço</label>
        <input
          className={`${alarmAddress && "alarm-input"}`}
          type="text"
          value={address}
          onChange={(event) => setAddress(event.target.value)}
          onFocus={() => setHideMenu(true)}
          onBlur={() => {
            setHideMenu(false);
            address === undefined || address === ""
              ? setAlarmAddress(true)
              : setAlarmAddress(false);
          }}
        />
        {alarmAddress && (
          <p className="alarm-text">Informe um endereço</p>
        )}
      </div>
      
      <div className="input">
        <label>Número</label>
        <input
          className={`${alarmNumber && "alarm-input"}`}
          type="text"
          value={number}
          onChange={(event) =>
            setNumber(
              event.target.value
                .replace(/[^0-9.]/g, "")
                .replace(/(\..*?)\..*/g, "$1")
            )
          }
          onFocus={() => setHideMenu(true)}
          onBlur={() => {
            setHideMenu(false);
            number === undefined || number === ""
              ? setAlarmNumber(true)
              : setAlarmNumber(false);
          }}
        />
        {alarmNumber && (
          <p className="alarm-text">
            Informe o número do endereço
          </p>
        )}
      </div>
      
      <div className="input">
        <label>Complemento</label>
        <input
          type="text"
          value={complement}
          onChange={(event) => setComplement(event.target.value)}
          onFocus={() => setHideMenu(true)}
          onBlur={() => setHideMenu(false)}
        />
      </div>
      
      <div className="input">
        <label>Bairro</label>
        <input
          className={`${alarmDistrict && "alarm-input"}`}
          type="text"
          value={district}
          onChange={(event) => setDistrict(event.target.value)}
          onFocus={() => setHideMenu(true)}
          onBlur={() => {
            setHideMenu(false);
            district === undefined || district === ""
              ? setAlarmDistrict(true)
              : setAlarmDistrict(false);
          }}
        />
        {alarmDistrict && (
          <p className="alarm-text">Informe um bairro</p>
        )}
      </div>
      
      <div className="inputs">
        <div className="input">
          <label>Cidade</label>
          <input
            disabled
            className={`${
              alarmCity && "alarm-input"
            } disabled-input`}
            type="text"
            value={city}
            onChange={(event) => setCity(event.target.value)}
            onFocus={() => setHideMenu(true)}
            onBlur={() => {
              setHideMenu(false);
              city === undefined || city === ""
                ? setAlarmCity(true)
                : setAlarmCity(false);
            }}
          />
          {alarmCity && (
            <p className="alarm-text">Informe uma cidade</p>
          )}
        </div>
        
        <div className="input" style={{ width: "20%" }}>
          <label>Estado</label>
          <input
            disabled
            className={`${
              alarmState && "alarm-input"
            } disabled-input`}
            type="text"
            value={state}
            onChange={(event) => setState(event.target.value)}
            onFocus={() => setHideMenu(true)}
            onBlur={() => {
              setHideMenu(false);
              state === undefined || state === ""
                ? setAlarmState(true)
                : setAlarmState(false);
            }}
          />
          {alarmState && (
            <p className="alarm-text">Informe um estado</p>
          )}
        </div>
      </div>
    </>
  );
}
